import { put, takeEvery } from "redux-saga/effects";
import { authorizedApi } from "tools/apiConfigurator";
import * as actions from "@p81-common/shell-core-js/dist/redux/regionsGet";

function* regionsGet(action) {
  try {
    let response = yield authorizedApi.get(`cpregions`).json();
    yield put(actions.requestSuccess(response.data.cpregions));
  } catch (e) {
    yield put(actions.requestFailure(e, action.id));
  }
}

function* saga() {
  yield takeEvery(actions.REGIONS_GET_REQUEST, regionsGet);
}

export default saga;
